import React from 'react';
import { useSelector } from 'react-redux';
import { Accordion } from '@gumtree/ui-library';
import styled from '@emotion/styled';
import { colors, fontSizes, fontWeights } from '@gumtree/ui-library/src/base/theme';

import { CUSTOM_FILTERS } from '../shared/constants';
import { trackFilterOpenChange } from '../shared/filters-utils';
import type { SrpState } from '../../reducers';

const SelectedValue = styled.span`
    color: ${colors.bark60};
    font-size: ${fontSizes.small};
    font-weight: ${fontWeights.normal};
`;

const CategoryAccordion = () => {
    const {
        resultsPage: { categoriesFilter },
    } = useSelector((data: SrpState): SrpState => data);
    const selectedCategory = categoriesFilter.selectedCategorySeoDisplayName;
    const title = selectedCategory ? (
        <>
            <div>Category</div>
            <SelectedValue>{selectedCategory}</SelectedValue>
        </>
    ) : (
        'Categories'
    );

    return (
        <Accordion
            key="categories"
            title={title}
            isFullscreenFilter
            onOpenChange={(open: boolean) => trackFilterOpenChange(open, CUSTOM_FILTERS.CATEGORIES)}
        />
    );
};

export default CategoryAccordion;
